/* Optima delivery estimate v2 (18 Oct 2026). Needs ob-geo.js. Markup and settings live in snippets/ob-delivery-estimate.liquid. */
(function () {
  function start() {
    if (!window.OBGeo) return setTimeout(start, 60);
    document.querySelectorAll('[data-obd]').forEach(init);
  }
  function init(root) {
    if (root.getAttribute('data-obd-ready')) return;
    root.setAttribute('data-obd-ready', '1');
    var G = window.OBGeo, cfg;
    try { cfg = JSON.parse(root.querySelector('.obd-cfg').textContent); } catch (e) { return; }
    var meta = cfg.meta || {};
    if (meta.days) { cfg.branded = meta.days; cfg.sample = meta.days; }
    if (meta.plain) cfg.plain = meta.plain;
    var HOL = {};
    (cfg.hol || []).forEach(function (k) { HOL[String(k).trim()] = 1; });
    var input = root.querySelector('.obd-q'), list = root.querySelector('.obd-list'), go = root.querySelector('.obd-go'),
        box = root.querySelector('.obd-search'), out = root.querySelector('.obd-out'), err = root.querySelector('.obd-err'),
        hint = root.querySelector('.obd-hint');
    var scope = root.closest('.product__info-container') || document;
    var worldUrl = root.getAttribute('data-world');

    // ---- calendar, all dates are calendar days in IST ----
    function ymd(d) { var m = d.getMonth() + 1, x = d.getDate(); return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (x < 10 ? '0' : '') + x; }
    function plus(d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); }
    function work(d) { return d.getDay() !== 0 && !HOL[ymd(d)]; }
    function intl(d) { var k = ymd(d).slice(5); return d.getDay() !== 0 && d.getDay() !== 6 && k !== '12-25' && k !== '01-01'; }
    function cal() { return true; }
    function add(d, n, ok) { var x = d; while (n > 0) { x = plus(x, 1); if (ok(x)) n--; } return x; }
    function roll(d, ok) { var x = d; while (!ok(x)) x = plus(x, 1); return x; }
    var loc = 'en-GB';
    function fmt(d) { try { return d.toLocaleDateString(loc, { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.toDateString().slice(0, 10); } }
    function range(a, b) { return ymd(a) === ymd(b) ? fmt(a) : fmt(a) + ' to ' + fmt(b); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function qty() {
      var s = document.getElementById('ob-qty-' + cfg.sid), v = s ? parseInt(s.value, 10) : NaN;
      if (!(v > 0)) { var q = scope.querySelector('input[name="quantity"]'); v = q ? parseInt(q.value, 10) : 1; }
      return v > 0 ? v : 1;
    }
    function branding() {
      var c = document.querySelector('#ob-brands-' + cfg.sid + ' .ob-brand-card.selected .ob-brand-name');
      if (c && c.textContent) return c.textContent.trim();
      var i = scope.querySelector('input[name="properties[Branding]"]');
      return i && i.value ? i.value : '';
    }

    // ---- estimate ----
    function estimate(pl) {
      var c = pl.cc, p = pl.tpc || '';
      loc = c === 'US' ? 'en-US' : 'en-GB';
      var n = new Date(), ist = new Date(n.getTime() + (n.getTimezoneOffset() + 330) * 60000);
      var today = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
      var early = ist.getHours() < cfg.cutoff;
      var base = work(today) && early ? today : roll(plus(today, 1), work);
      var q = qty(), kg = Math.round(q * cfg.kg * 10) / 10, br = branding(), plain = /^plain/i.test(br);
      var prep = cfg.kind === 'ready' ? null : cfg.kind === 'sample' ? cfg.sample : plain ? cfg.plain : cfg.branded;
      var proof = null, d1, d2;
      if (prep) { proof = add(base, 1, work); d1 = add(proof, prep[0], work); d2 = add(proof, prep[1], work); }
      else { d1 = base; d2 = add(base, 1, work); }
      var ms = [];
      if (c === 'IN') {
        var r = pl.region || G.inRegion(p);
        ms.push({ n: 'Free surface delivery', t: r.s, ok: work });
        if (kg <= 100) ms.push({ n: 'Express Air, paid at checkout', t: r.e, ok: work });
      } else {
        var ra = G.remote(c, p);
        if (kg <= 100) {
          ms.push({ n: 'Express courier (DHL, UPS or FedEx)', t: [3 + ra[0], 6 + ra[1]], ok: intl });
          ms.push({ n: 'Economy courier, where offered', t: [6 + ra[0], 10 + ra[1]], ok: intl });
        }
        if (kg >= 40) ms.push({ n: 'Air freight, door to door', t: [7 + ra[0], 12 + ra[1]], ok: intl });
        if (kg >= 150) ms.push({ n: 'Sea freight, door to door', t: [35, 60], ok: cal });
      }
      ms.forEach(function (m) { m.a = add(d1, m.t[0], m.ok); m.b = add(d2, m.t[1], m.ok); });
      return { today: today, base: base, early: early, ist: ist, q: q, kg: kg, br: br, prep: prep, proof: proof, d1: d1, d2: d2, ms: ms };
    }

    function textHtml(pl, e) {
      var main = e.ms[0];
      var h = '<div class="obd-eta obd-a"><span class="obd-k">Arrives</span><strong>' + range(main.a, main.b) + '</strong></div>';
      h += '<div class="obd-to obd-a">To ' + esc(pl.place) + ' by ' + esc(main.n.charAt(0).toLowerCase() + main.n.slice(1)) + '.</div>';
      h += '<ol class="obd-steps">';
      if (e.prep) {
        var what = cfg.kind === 'sample' ? 'Sample made and dispatched' : 'Made and dispatched from our factory';
        h += '<li class="obd-a obd-done"><b>Today</b>You place the order' + (ymd(e.base) === ymd(e.today) ? '' : '. We start work on ' + fmt(e.base) + '.') + '</li>';
        h += '<li class="obd-a"><b>By ' + fmt(e.proof) + '</b>Proof in your inbox. Approve it the same day to keep these dates.</li>';
        h += '<li class="obd-a"><b>' + range(e.d1, e.d2) + '</b>' + what + ', ' + e.prep[0] + ' to ' + e.prep[1] + ' working days after you approve the proof</li>';
      } else {
        h += '<li class="obd-a obd-done"><b>' + range(e.d1, e.d2) + '</b>Dispatched from our factory near Delhi</li>';
      }
      h += '<li class="obd-a"><b>' + range(main.a, main.b) + '</b>Delivered</li></ol>';
      if (!e.prep && ymd(e.base) === ymd(e.today)) {
        var mins = cfg.cutoff * 60 - (e.ist.getHours() * 60 + e.ist.getMinutes());
        if (mins > 0) h += '<span class="obd-cd obd-a">Order within ' + (mins >= 60 ? Math.floor(mins / 60) + ' h ' : '') + (mins % 60) + ' min to ship today</span>';
      }
      if (e.ms.length > 1) {
        h += '<ul class="obd-alt obd-a">';
        for (var i = 1; i < e.ms.length; i++) h += '<li><span>' + esc(e.ms[i].n) + '</span><b>' + range(e.ms[i].a, e.ms[i].b) + '</b></li>';
        h += '</ul>';
      }
      var foot = 'Estimate for ' + e.q + (e.q === 1 ? ' unit' : ' units') + ', about ' + e.kg + ' kg';
      if (e.br && cfg.kind === 'made') foot += ', ' + esc(e.br.replace(/\s+[–—-]\s+/, ', '));
      foot += '. Dates skip Sundays and factory holidays. You pick the shipping method and see the cost at checkout.';
      h += '<p class="obd-foot obd-a">' + foot + '</p>';
      if (pl.type === 'country' && G.NOPC.indexOf(' ' + pl.cc + ' ') < 0) h += '<p class="obd-more obd-a">Add your ' + (G.PCLABEL[pl.cc] || 'postcode').toLowerCase() + ' for a closer date.</p>';
      return h;
    }

    var current = null, mapSvg = null;
    function render(pl, animate) {
      current = pl;
      var e = estimate(pl);
      var res = out.querySelector('.obd-res');
      if (!res || animate) {
        out.innerHTML = '<div class="obd-res"><div class="obd-map" aria-hidden="true"></div><div class="obd-text"></div><button type="button" class="obd-change">Change location</button></div>';
        res = out.querySelector('.obd-res');
        res.querySelector('.obd-change').addEventListener('click', function () { input.value = ''; input.focus(); out.innerHTML = ''; current = null; if (hint) hint.hidden = false; try { localStorage.removeItem('obd2'); } catch (x) {} });
      }
      var txt = res.querySelector('.obd-text');
      txt.innerHTML = textHtml(pl, e);
      if (hint) hint.hidden = true;
      if (!animate) { res.classList.add('is-in'); return; }
      res.classList.remove('is-in');
      animateMap(res.querySelector('.obd-map'), pl).then(function () { res.classList.add('is-in'); });
      setTimeout(function () { res.classList.add('is-in'); }, 1500);
    }

    function animateMap(boxEl, pl) {
      if (!worldUrl) return Promise.resolve();
      return G.mount(boxEl, worldUrl).then(function (svg) {
        mapSvg = svg;
        var A = G.proj(G.ORIGIN.lat, G.ORIGIN.lon), B = G.proj(pl.lat, pl.lon);
        var aspect = boxEl.clientWidth && boxEl.clientHeight ? boxEl.clientWidth / boxEl.clientHeight : 2.2;
        var dom = pl.cc === 'IN';
        var target = dom ? (function () { var w = Math.max(210, 98 * aspect), h = w / aspect; return [722 - w / 2, 172 - h / 2, w, h]; })() : G.fit(A, B, aspect, 300);
        var startV = [0, 200 - 500 / aspect, 1000, 1000 / aspect];
        G.setVB(svg, startV);
        var dest = svg.querySelector('.obw-dots path[data-c="' + pl.cc + '"]');
        if (dest) dest.classList.add('is-dest');
        if (dom) { svg.classList.add('is-in'); var fin = svg.querySelector('.obw-fine path[data-c="IN"]'); if (fin) fin.classList.add('is-dest'); }
        return G.animateVB(svg, target, 850).then(function () {
          var ov = svg.querySelector('.obw-ov'), w = target[2];
          ov.innerHTML = '';
          var r = w * 0.0075, fs = w * 0.025;
          G.pin(ov, A, r, 'is-origin');
          var near = dom && pl.region && pl.region.near;
          var oLabel = G.label(ov, A, 'Kundli, India', fs, 'is-origin', 0, -r * 3.2);
          if (near) {
            oLabel.textContent = 'Our factory is next door';
            return new Promise(function (res) { setTimeout(res, 500); });
          }
          var lift = B[0] < A[0] ? 1 : -1;
          return G.travel(ov, G.arcD(A, B), { ms: 1150, sw: w * 0.0045, icon: true, size: w * 0.022 }).then(function () {
            G.pin(ov, B, r, 'is-dest');
            var name = pl.type === 'city' ? pl.c[0] : pl.type === 'pc' ? (pl.sub.split(',')[0] || pl.country) : pl.country;
            G.label(ov, B, name, fs, 'is-dest', 0, -r * 3.2);
          });
        });
      }).catch(function () { boxEl.remove(); });
    }

    // ---- search box ----
    var items = [], active = -1;
    function openList(show) { list.hidden = !show; box.setAttribute('aria-expanded', show ? 'true' : 'false'); }
    function draw() {
      if (!items.length) { list.innerHTML = ''; openList(false); return; }
      list.innerHTML = items.map(function (s, i) {
        return '<li role="option" id="' + list.id + '-' + i + '" class="obd-opt' + (i === active ? ' is-active' : '') + '" data-i="' + i + '" aria-selected="' + (i === active) + '">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>' +
          '<span><b>' + esc(s.main) + '</b><small>' + esc(s.sub) + '</small></span></li>';
      }).join('');
      if (active > -1) input.setAttribute('aria-activedescendant', list.id + '-' + active); else input.removeAttribute('aria-activedescendant');
      openList(true);
    }
    function suggest() {
      err.textContent = '';
      items = G.search(input.value, cfg.country);
      active = items.length ? 0 : -1;
      draw();
    }
    function choose(s) {
      if (!s) return;
      input.value = s.type === 'country' ? s.main : s.main + ', ' + (s.type === 'city' ? s.country : s.sub);
      items = []; draw();
      try { localStorage.setItem('obd2', JSON.stringify({ v: 1, q: input.value, s: { type: s.type, cc: s.cc, pc: s.pc || '', city: s.c ? s.c[0] : '' } })); } catch (x) {}
      render(s, true);
    }
    function submit() {
      if (!input.value.trim()) { err.textContent = 'Type a ZIP code, PIN code, postcode, city or country.'; input.focus(); return; }
      var s = items[active > -1 ? active : 0] || G.search(input.value, cfg.country)[0];
      if (!s) { err.textContent = 'No match found. Try a ZIP code, a city like London, or a country.'; return; }
      choose(s);
    }
    input.addEventListener('input', suggest);
    input.addEventListener('focus', function () { if (input.value && !current) suggest(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (items.length) { active = (active + 1) % items.length; draw(); } }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (items.length) { active = (active - 1 + items.length) % items.length; draw(); } }
      else if (e.key === 'Enter') { e.preventDefault(); submit(); }
      else if (e.key === 'Escape') { items = []; draw(); }
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) { var li = e.target.closest('.obd-opt'); if (li) choose(items[+li.getAttribute('data-i')]); });
    go.addEventListener('click', submit);
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) { items = []; draw(); } });

    // live updates when quantity or branding changes
    var timer;
    function again() { if (!current) return; clearTimeout(timer); timer = setTimeout(function () { render(current, false); }, 160); }
    document.addEventListener('input', function (e) { var t = e.target; if (t && t !== input && (t.id === 'ob-qty-' + cfg.sid || t.name === 'quantity' || t.type === 'range')) again(); }, true);
    document.addEventListener('change', function (e) { if (e.target !== input) again(); }, true);
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.ob-brand-card,.quantity__button')) again(); }, true);

    // restore this visitor's own last search, animate when the box scrolls into view
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('obd2') || 'null'); } catch (x) {}
    if (saved && saved.s && saved.q) {
      var cand = G.search(saved.q, cfg.country).filter(function (s) { return s.type === saved.s.type && s.cc === saved.s.cc && (s.pc || '') === saved.s.pc && (s.c ? s.c[0] : '') === saved.s.city; })[0];
      if (cand) {
        input.value = saved.q;
        var fire = function () { render(cand, true); };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); fire(); } }, { threshold: 0.3 });
          io.observe(root);
        } else fire();
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
